import React from 'react';
import { Box } from '@chakra-ui/core';

interface CustomSwitchProps {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
  isDisabled?: boolean;
  'data-testid'?: string;
}

export const CustomSwitch: React.FC<CustomSwitchProps> = ({ isChecked, onChange, isDisabled = false, ...rest }) => {
  const handleToggle = () => {
    if (isDisabled) return;
    onChange(!isChecked);
  };

  return (
    <Box
      as="button"
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={isDisabled}
      onMouseDown={(e: React.MouseEvent) => {
        e.preventDefault();
      }}
      onClick={handleToggle}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          handleToggle();
        }
      }}
      position="relative"
      display="inline-flex"
      alignItems="center"
      width="36px"
      height="20px"
      borderRadius="full"
      bg={isChecked ? 'blue.500' : 'gray.300'}
      transition="background-color 0.15s ease"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.5 : 1}
      _focusVisible={{
        boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.5)',
      }}
      {...rest}
    >
      <Box
        position="absolute"
        top="2px"
        left={isChecked ? '18px' : '2px'}
        width="16px"
        height="16px"
        borderRadius="full"
        bg="white"
        boxShadow="0 1px 2px rgba(0,0,0,0.2)"
        transition="left 0.15s ease"
      />
    </Box>
  );
};
